import script from "./CheckOutSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckOutSection.vue?vue&type=script&lang=ts&setup=true"

import "./CheckOutSection.vue?vue&type=style&index=0&id=1483c8e0&scoped=true&lang=scss"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1483c8e0"]])

export default __exports__